const headline = document.getElementById('Bannertitle');
const wrapper= document.querySelector('#Video');
const video = wrapper.querySelector('video');
const headers = JSON.parse(wrapper.dataset.headers);
const track = video.addTextTrack("chapters", "German", "de")
let start = 0;

headers.forEach((item) => {
    let end = start + item.time;
    track.addCue(new VTTCue(start, end, item.text));
    start = end;
})

track.addEventListener('cuechange', function(e){
    if(this.activeCues[0]) {
        headline.textContent = this.activeCues[0].text;
    }
});

track.mode = "showing";
